import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output
} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SaLockFilter} from "./saLock.filter";
import { debounceTime } from 'rxjs/operators';
import {SaLockControllerFilter} from "./saLockController.filter";
import {SettingsPersistenceService} from "../../services/settings-persistence.service";
import {element} from "protractor";
import {json} from "@angular-devkit/core";

@Component({
  selector: 'micro-saLockControllers',
  templateUrl: './saLockControllers.component.html'
})
export class SaLockControllersComponent implements OnInit, OnDestroy, OnChanges  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SaLockControllerFilter = new SaLockControllerFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  @Input()
  siteId:any;

  @Input()
  cabinetId:any;

  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  selectionMode:string;

  @Input()
  selectedRow:any;

  @Output()
  selectedRowChange:EventEmitter<any> = new EventEmitter<any>();

  embedded:boolean = false;
  pageSettings:SettingsPersistenceService;

  onSelectedRowChange() {
    this.selectedRowChange.emit(this.selectedRow);
  }


  constructor(public auth:AuthService,
              private env:EnvService,
              private http:HttpClient) {

  }

  ngOnInit() {
    this.embedded = !!(this.cabinetId || this.siteId);
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.sa.lockControllers");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .setEmbedded(this.embedded)
      .setEmbeddedFilterProps(this.embedded ? {siteId: this.siteId, cabinetId: this.cabinetId} : undefined)
      .init();

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reloadDebounce();
    });

    // TODO: verify this now gets set by pageSettings
    // if (this.cabinetId) {
    //   this.filter.cabinetId = this.cabinetId;
    // }
    //
    // if (this.siteId) {
    //   this.filter.siteId = this.siteId;
    // }

    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => {
      this.reload();
    });
    this.reloadDebounce();
  }

  reloadDebounce() {
    this.reloadDebouncer.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'cabinetId' || prop === 'siteId') {
        this.embedded = !!(this.cabinetId || this.siteId);
        if (this.cabinetId) {
          this.filter.cabinetId = this.cabinetId;
        }

        if (this.siteId) {
          this.filter.siteId = this.siteId;
        }
        this.pageSettings.setEmbeddedFilterProps(this.embedded ? {siteId: this.siteId, cabinetId: this.cabinetId} : undefined);
        this.reloadDebounce();
      }
    }
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
      ;

    this.http.get(`${this.env.e.url}/access/saLocks/controllers`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  firmwareVersion(element: any) {
    if (element.gitBranch && element.gitRevision) {
      return element.gitBranch + "#" + element.gitRevision;
    }
    return "";
  }

  getFirmwareConfigObj(element:any) {
    if (element.firmwareConfig && !element.firmwareConfigObj) {
      try {
        element.firmwareConfigObj = JSON.parse(element.firmwareConfig);
      } catch (e) {
        element.firmwareConfigObj = {};
      }
    }
    return element.firmwareConfigObj;
  }

  firmwareProfile(element: any) {
    var firmwareConfigObj = this.getFirmwareConfigObj(element);
    return firmwareConfigObj.profile ? firmwareConfigObj.profile : "";
  }
}
